export default __webpack_public_path__ + "static/media/100.8a1740d2.gif";